import {
  NgModule,
} from '@angular/core';
import {
  RulesEngineRunnerModule,
} from '@o3r/rules-engine';
import {
  TechnicalDetailsFactsService,
} from './technical-details.facts.service';

@NgModule({
  imports: [
    RulesEngineRunnerModule
  ],
  providers: [
    TechnicalDetailsFactsService
  ]
})
export class TechnicalDetailsFactsModule {}
